// Look of the nationwide dots (R94/R95, Max 24.10.): small dots (RADIUS_STOPS in map-geometry.mjs) whose opacity rises with
// the zoom, from 5 % with Europe in view to 70 % at z10 (a city on a phone). Overlaps add up on purpose and show where many
// sites are; from z12 the dots also turn opaque towards the pins. Drawn by the WebGL custom layer (gpu-dots.mjs, R92); the
// hidden ?dots=circle keeps the GeoJSON circle layer as a fallback until the GPU path has proven itself on phone and car.
import {stopsAt} from './map-geometry.mjs';
// Opacity factor for sites that are not search results while results are focused (Max 28.10.: 0.25 hid them).
export const FOCUS_DIM=.6;
export const OPACITY_STOPS=[[2.5,.05],[10,.7],[12,.7],[14,1]];
export function dotMode(search=globalThis.location?.search??''){
  const circle=new URLSearchParams(search).get('dots')==='circle';
  return {gpu:!circle,param:circle?'circle':null};
}
export const zoomCurve=stops=>['interpolate',['linear'],['zoom'],...stops.flat()];
// Opacity of the dot layer; `focus` is 1 or the dimming factor while search results are focused.
export const dotOpacity=focus=>zoomCurve(OPACITY_STOPS.map(([z,o])=>[z,+(o*focus).toFixed(4)]));
export const dotOpacityAt=zoom=>stopsAt(OPACITY_STOPS,zoom);
